module.exports = __webpack_public_path__ + "img/caret-right.08a42724.svg";